import { faArrowUpFromBracket, faLocationDot, faWalking } from "@fortawesome/free-solid-svg-icons"
import HomeSearch from "../components/elements/HomeSearch"
import Icon from "../components/Icon"
import Container from "../layout/Container"
import Navbar from "../layout/Navbar"
import NearbyCard from "../components/cards/NearbyCard"

import Hero from '../assets/images/hero.png'
import ReviewCard from "../components/cards/ReviewCard"
import { Link, useParams } from "react-router-dom"
import { getHotelDetails } from "../apis"
import { useFetch } from "../hooks/useFetch"
import useWidth from "../hooks/useWidth"
import MobileHeader from "../layout/MobileHeader"
import MobileHeaderSearch from "../components/MobileHeaderSearch"

import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";

import { useState } from "react"
import { ObjectToParams } from "../utils"
import Loader from "../components/elements/Loader"
import ImageSlider from "../components/elements/ImageSlider"
import { SwiperSlide } from "swiper/react"
import Share from "../components/elements/Share"
import HotelForm from "./HotelForm"


export default () => {
    const params = useParams()
    const width = useWidth()

    const [ state, setState ] = useState({ checkIn: null, checkOut: null, room: null, guest: null, hotelId: params.hotelId })
    const [hotel,,loading] = useFetch(getHotelDetails, {}, params.hotelId)

    return (
        <>
        <Loader loading={loading} />
            {
                width > 992 ? <Navbar gradient />
                : <MobileHeader>
                    <MobileHeaderSearch placeholder="Search Tour& Events" />
                </MobileHeader>
            }
            <Container >

                <section className="mobile-top-space desktop-top-space pt-3">
                    <div className="d-flex">
                        <h3 className="custom-text-color">{ hotel.hotelName }</h3>
                        <Share title={hotel.name} text={hotel.shareDescription || hotel.description} />
                    </div>
                    <p className="custom-text-color"><Icon icon={faLocationDot} className="text-saffron me-3" /> { hotel.address }</p>


                    {/* Accomodation Gallery */}
                   {width > 992 ? <div className="row mt-5">
                        <div className="col-lg-8 col-md-12">
                            <div style={{ width:"100%", height:"400px"}}>
                                <img src={hotel?.files?.at(0)?.Url || Hero} className="w-100 h-100 rounded-4 image-cover" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="row">
                                {hotel?.files?.at(1) && <div className="col p-0">
                                    <div className="p-2" style={{ width: "100%", height:"200px" }}>
                                        <img src={hotel?.files?.at(1)?.Url}  className="rounded-4 w-100 h-100 image-cover"/>
                                    </div>
                                </div>}
                                {hotel?.files?.at(2) && <div className="col p-0">
                                    <div className="p-2" style={{ width: "100%", height:"200px" }}>
                                        <img src={hotel?.files?.at(2)?.Url}  className="rounded-4 w-100 h-100 image-cover"/>
                                    </div>
                                </div>}
                            </div>
                            <div className="row">
                                {hotel?.files?.at(3) && <div className="col p-0">
                                    <div className="p-2" style={{ width: "100%", height:"200px" }}>
                                        <img src={hotel?.files?.at(3)?.Url}  className="rounded-4 w-100 h-100 image-cover"/>
                                    </div>
                                </div>}
                                {hotel?.files?.at(4) && <div className="col p-0">
                                    <div className="p-2 position-relative group-photos w-100" style={{ height:"200px" }}>
                                        <img src={hotel?.files?.at(4)?.Url}  className="rounded-4 w-100 h-100 image-cover"/>
                                        {hotel?.files?.length >= 5 && <div className="position-absolute text-white bold text-center" style={{ top: "40%", left: "25%"}}>
                                            <p>+{ hotel?.files?.length - 5 } Photos</p>
                                        </div>}
                                    </div>
                                </div>}
                            </div>
                        </div>
                        
                    </div>
                    :
                    <>
                        <ImageSlider pagination={{ clickable: true }} >
                            {
                                hotel?.files?.map(( file, i ) => 
                                    <SwiperSlide key={i}>
                                        <div style={{ height: "300px"}}>
                                            <img src={file.Url} className="w-100 h-100 image-cover rounded-3"/>
                                        </div>
                                    </SwiperSlide>
                                )
                            }
                        </ImageSlider>
                    </>
                    }
                    {/* Accomodation allery End */}

                    <div className="row">
                        <div className="col-lg-8 col-md-12">

                            {/* About Section */}
                            <div className="mt-5">
                                <h4 className="custom-text-color">About the Hotel</h4>
                                <p>
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto rerum laborum distinctio sit sunt tenetur omnis sequi quibusdam, eveniet deserunt iure nobis fuga quam pariatur itaque dolore molestias modi a temporibus aliquam cupiditate fugiat perferendis. Blanditiis, earum necessitatibus et officiis optio neque tempore expedita doloribus sunt voluptatibus ex iste placeat esse, suscipit aperiam enim quos deleniti ea at mollitia ipsam odio totam? Quos ea, nesciunt vel beatae hic laboriosam quo cupiditate ab dignissimos consectetur nostrum sunt officiis ullam possimus. Ut, autem! Quas reprehenderit architecto fugiat aliquam, corporis ullam, alias maxime in nam quo sit id deleniti consequatur error accusantium. Debitis!

                                    <br/>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ea repellat ipsam animi necessitatibus doloribus nam quasi, debitis quo fuga natus, consequatur esse ipsa, vel recusandae repudiandae voluptas iure veritatis? Veniam cum fugit voluptate dignissimos modi temporibus. Eaque possimus quibusdam eum, provident ea officiis autem tempore dolorum necessitatibus odit, id omnis?
                                </p>
                            </div>
                            
                            {/* About Section End */}

                            {/* Facilities Section */}
                            <div className="mt-5">
                                <h4 className="custom-text-color">Most popular facilities</h4>
                                <div className="mt-4 d-flex flex-wrap gap-4">
                                    {
                                        hotel?.amenitiesId?.map(( amenity, i ) => 
                                            <div className=" d-flex align-items-center">
                                                <div className="me-2" style={{ width: "30px" }}>
                                                    <img src={amenity.file?.Url} className="w-100 h-100" />
                                                </div>
                                                <p className="mb-0">{ amenity.name }</p>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            {/* Facilities Section End */}

                            

                        </div>
                        <div className="col-lg-4 col-md-12">
                            <HotelForm hotel={hotel}/>
                        </div>

                        <div className="col-12">
                            {/* Near By Section */}
                            <div className="mt-5">
                                <div className="row">
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                        <div  className="card rounded-4 p-3 my-2">
                                            <h4 className="mb-4">Top Sites:</h4>
                                            {
                                                Array(4).fill(0).map(_ =>
                                                    <NearbyCard data={{ image: Hero, name: "Harjis Garden", description: "650m"}} />
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                        <div  className="card rounded-4 p-3 my-2">
                                            <h4 className="mb-4">Restaurants:</h4>
                                            {
                                                Array(4).fill(0).map(_ =>
                                                    <NearbyCard data={{ image: Hero, name: "Golden Fill Restaurant (Pure Veg)", description: "650m"}} />
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                        <div  className="card rounded-4 p-3 my-2">
                                            <h4 className="mb-4">Transportation:</h4>
                                            {
                                                Array(4).fill(0).map(_ =>
                                                    <NearbyCard data={{ image: Hero, name: "ISBT Bus Stand", description: "65m"}} />
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Near By End */}

                        </div>
                        <div className="col-12">
                            <div className="d-flex align-items-center mt-5">
                                <h4 className="custom-text-color me-4 mb-0">Nirvana Hills Resort Reviews</h4>
                                <select className="form-control w-25" style={{ borderRadius: "20px" }}>
                                    <option>Sort By: Most Relevant</option>
                                    <option>Sort By: high to low</option>
                                </select>
                            </div>
                            <div className="row mt-4">

                                <div className="col-lg-4 col-md-6 col-sm-12 p-0 m-0">
                                    <ReviewCard />
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12 p-0 m-0">
                                    <ReviewCard />
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12 p-0 m-0">
                                    <ReviewCard />
                                </div>
                            </div>
                        </div>
                    </div>

                </section>

            </Container>
        </>
    )
}